// extracted by mini-css-extract-plugin
export var base = "_43-0";
export var updateBanner = "_43-1";